const SERVICE = "payment";

const getPaymentProviderList = async (api) =>
  api.setMethod().get().setService(SERVICE).process("/gatewaylist");

const ozopay = async (api, uuid) =>
  api.setMethod().get().setService(SERVICE).process(`/ozopayb2c/${uuid}`);

const ozopayPayment = async (api, transactionId, body) =>
  api.setService(SERVICE).client.request({
    method: "GET",
    data: body,
    url: `${api.service}/ozopayb2c/${transactionId}`,
    headers: {
      ...api.optionsObject.headers,
      "Content-Type": "multipart/form-data",
    },
  });

module.exports = {
  getPaymentProviderList,
  ozopayPayment,
  ozopay,
};
